import React, { useCallback, useEffect, useMemo, useState } from 'react';
import SettingsCard from '../../organisms/SettingsCard';
import Stepper from '../../organisms/Stepper';
import TableCardGrid from '../../organisms/TableCardGrid';
import TatMinutesProgress from '../../molecules/TatMinutesProgress';
import { useSettingsWizard } from '../../../context/SettingsWizardContext';
import { SETTINGS_STEPS } from '../../../data/settingsSteps';
import { useDispatch, useSelector } from 'react-redux';
import { updateWorkflowSteps } from '../../../redux/Workflow/actions';
import { fetchComplaintTypeById } from '../../../redux/complaintType/actions';
import { formatDurationInMessage, getAllocatedMinutesFromAllLevels, parseDurationToMinutes } from '../../../utils/duration';

function unwrapId(value) {
  return value?.data ?? value?.id ?? value;
}




export default function WorkflowStep({
  onNext: _onNext,
  stepMeta,
  stepperProps,
  selectedTableCard,
  roleList = [],

}) {
  const { state, updateWorkflow: updateWizardWorkflow } = useSettingsWizard();
  const { workflow } = state;

  // Roles already chosen in step 1 (Category Type) are hidden from the Workflow role list
const categoryRoleIds = state.categoryRoleIds;
const workflowRoleList = useMemo(() => {
  const blocked = new Set(
    (Array.isArray(categoryRoleIds) ? categoryRoleIds : []).map(String),
  );
  if (!blocked.size) return roleList;
  return roleList.filter((role) => !blocked.has(String(role.id ?? role.value)));
}, [categoryRoleIds, roleList]);

  const [updatePayload, setUpdatePayload] = useState(null);
  const [saveError, setSaveError] = useState('');
  const handleUpdatePayload = useCallback((payload) => {
    setUpdatePayload(payload);
  }, []);
  const dispatch = useDispatch();


  let { id } = useSelector((state) => state.appDetails || {});
  const selectedType = useSelector((state) => state.complaintType?.selected);
  const typeId = unwrapId(id);
  const selectedTypeId = unwrapId(selectedType?.id ?? selectedType?._id);
  const tatTotal = parseDurationToMinutes(selectedType?.tatMinutes ?? state.tatMinutes);

  useEffect(() => {
    if (typeId == null || typeId === '') return undefined;
    if (selectedTypeId != null && String(selectedTypeId) === String(typeId) && selectedType?.tatMinutes != null) {
      return undefined;
    }
    dispatch(fetchComplaintTypeById(typeId));
    return undefined;
  }, [dispatch, selectedType?.tatMinutes, selectedTypeId, typeId]);

  const usedMinutes = useMemo(() => {
    const workflowLevels = Array.isArray(updatePayload?.tables) ? updatePayload.tables : [];
    return getAllocatedMinutesFromAllLevels(workflowLevels);
  }, [updatePayload]);
 
  // const { id } = useParams();



  

  // const SelectedTableCard=null;
  const resolvedSelectedTableCard = selectedTableCard ?? workflow.selectedTableCard ?? null;
  const workflowDescription = Array.isArray(updatePayload?.tables) && updatePayload.tables.length
    ? updatePayload.tables.map((_, index) => `L${index + 1}`).join(' > ')
    : '';


  const onSubmit = async () => {
    setSaveError('');
    if (!updatePayload) {
      setSaveError('Workflow steps are not ready to save.');
      return;
    }

    // console.log('WorkflowStep update payload:', updatePayload);
    dispatch(
      updateWorkflowSteps({
        id: updatePayload.id,
        tables: updatePayload,
        onSuccess: (data) => {
          console.log('updateWorkflowSteps onSuccess:', data);
          setSaveError('');
          stepperProps.onNext?.();
        },
        onFail: (error) => {
          const data = error?.response?.data ?? error?.payload ?? error;
          const details = Array.isArray(data?.errors)
            ? data.errors.map((item) => item?.message).filter(Boolean)
            : [];
          const message =
            (details.length ? details.join(' ') : null) ??
            data?.message ??
            data?.error ??
            error?.message ??
            'Failed to update workflow steps';
          // console.log('updateWorkflowSteps onFail:', error);
          setSaveError(formatDurationInMessage(message));
        },
      }),
    );

    // if (updateWorkflowSteps.fulfilled.match(resultAction)) {
    //   stepperProps.onNext?.();
    // }
  };

  return (
    <>
      {/* Main wizard stepper */}
      <Stepper
        {...stepperProps}
        steps={SETTINGS_STEPS}
        onNext={onSubmit}
        showNextButton
      />
      {saveError ? (
        <div className="ca-validation-toast" role="alert">
          {saveError}
        </div>
      ) : null}

      <SettingsCard
        title={stepMeta.title}
        description={workflowDescription}
        showNext={false}
        headerExtra={<TatMinutesProgress totalMinutes={tatTotal} usedMinutes={usedMinutes} />}
      >
     

          {/* Workflow Table Grid */}
          <div className="ca-workflow__main">
            <TableCardGrid
              id={id}
              selectedTableId={resolvedSelectedTableCard?.id}
              onSelect={(table) => updateWizardWorkflow({ selectedTableCard: table })}
              setUpdatePayload={handleUpdatePayload}
              roleList={workflowRoleList}
              showRoleError={/roleIds|role\s*must contain|roles?\s*must contain/i.test(saveError)}
              prefillSteps={state.prefillWorkflowSteps}
              tatTotalMinutes={tatTotal}
            />
          </div>
        {/* </div> */}
      </SettingsCard>
    </>
  );
}